import React, { memo } from 'react';
import PropTypes from 'prop-types';

const CustomXAxisTick = ({ x, y, payload }) => (
  <g transform={`translate(${x},${y})`} className="custom-x-axis-tick">
    <text x={0} y={0} dy={16}>
      {payload.value}
    </text>
  </g>
);

CustomXAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({
    value: PropTypes.any,
  }),
};

export default memo(CustomXAxisTick);
